var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 38.6666L28.6663 33.6666M35.333 30.3333L43.6663 25.3333M31.9997 20.3333V28.6666M31.9997 35.3333V43.6666M20.333 25.3333L28.6663 30.3333M35.333 33.6666L43.6663 38.6666M46.1663 26.9999V36.1666M34.4997 46.1666L43.6663 41.1666M19.4997 41.1666L29.4997 46.1666M17.833 36.9999V26.9999M19.4997 22.8333L29.4997 17.8333M44.4997 22.8333L34.4997 17.8333",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.3333C33.3807 20.3333 34.5 19.214 34.5 17.8333C34.5 16.4525 33.3807 15.3333 32 15.3333C30.6193 15.3333 29.5 16.4525 29.5 17.8333C29.5 19.214 30.6193 20.3333 32 20.3333Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.6665C33.3807 48.6665 34.5 47.5472 34.5 46.1665C34.5 44.7858 33.3807 43.6665 32 43.6665C30.6193 43.6665 29.5 44.7858 29.5 46.1665C29.5 47.5472 30.6193 48.6665 32 48.6665Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 27C19.2137 27 20.333 25.8807 20.333 24.5C20.333 23.1193 19.2137 22 17.833 22C16.4523 22 15.333 23.1193 15.333 24.5C15.333 25.8807 16.4523 27 17.833 27Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.166 27C47.5467 27 48.666 25.8807 48.666 24.5C48.666 23.1193 47.5467 22 46.166 22C44.7853 22 43.666 23.1193 43.666 24.5C43.666 25.8807 44.7853 27 46.166 27Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.166 42C47.5467 42 48.666 40.8807 48.666 39.5C48.666 38.1193 47.5467 37 46.166 37C44.7853 37 43.666 38.1193 43.666 39.5C43.666 40.8807 44.7853 42 46.166 42Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 42C19.2137 42 20.333 40.8807 20.333 39.5C20.333 38.1193 19.2137 37 17.833 37C16.4523 37 15.333 38.1193 15.333 39.5C15.333 40.8807 16.4523 42 17.833 42Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 28.25L35.3327 30.125V33.875L31.9993 35.75L28.666 33.875V30.125L31.9993 28.25Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsOn);
export default __webpack_public_path__ + "static/media/hands-on.fd871969cd51a287dfd927c1d2be3599.svg";
export { ForwardRef as ReactComponent };